module.exports = __webpack_public_path__ + "images/js_src_vue/page_islide_landing/islide-banner-right-5e04a45e.png";